import { useCallback, useState } from 'react';
import useResizeObserver from 'use-resize-observer';

const SUBPIXEL_TOLERANCE_PX = 1;

export const useModalScrollState = () => {
  const [scrollArea, setScrollArea] = useState<HTMLDivElement | null>(null);
  const [content, setContent] = useState<HTMLDivElement | null>(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);

  const sync = useCallback(() => {
    if (!scrollArea) {
      return;
    }
    setIsScrolled(scrollArea.scrollTop > 0);
    setIsScrollable(scrollArea.scrollHeight > scrollArea.clientHeight + SUBPIXEL_TOLERANCE_PX);
  }, [scrollArea]);

  useResizeObserver({ ref: scrollArea, onResize: sync });
  useResizeObserver({ ref: content, onResize: sync });

  return {
    scrollAreaRef: setScrollArea,
    contentRef: setContent,
    onScroll: sync,
    isScrolled,
    isScrollable,
  };
};
